/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleARightIcon24Regular = forwardRef('ArrowShapeTriangleARightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.25 5.436c0-1.386 1.535-2.222 2.7-1.47l10.157 6.564a1.75 1.75 0 0 1 0 2.94L8.95 20.033c-1.165.752-2.7-.084-2.7-1.47V5.436Zm1.886-.21a.25.25 0 0 0-.386.21v13.127c0 .198.22.317.386.21l10.157-6.563a.25.25 0 0 0 0-.42L8.136 5.226Z" })));
});
